import { Flex, Stack, Text } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { formatDate, formatNumberCurrency } from '@blockpulse3/helpers';

type Props = {
  amount: number;
  debtorName?: string | null;
  label: string;
  reference: string;
  date: Date;
};

export function TransferReceived({
  amount,
  debtorName,
  label,
  reference,
  date,
}: Props): JSX.Element {
  const i18nSubscriberDetailsSidePanel = useTranslations('SubscriberDetailsSidePanel');

  return (
    <Stack spacing={1}>
      <Text fontSize="sm">
        {i18nSubscriberDetailsSidePanel.rich('Activity.Transfer.Title', {
          amount: formatNumberCurrency(amount),
          important: (chunks) => (
            <Text as="span" fontWeight="600">
              {chunks}
            </Text>
          ),
        })}
      </Text>
      <Stack color="gray.500" spacing={1}>
        {debtorName && (
          <Flex justifyContent="space-between">
            <Text>{i18nSubscriberDetailsSidePanel('Activity.Transfer.Debtor')}:</Text>
            <Text>{debtorName}</Text>
          </Flex>
        )}
        <Flex justifyContent="space-between">
          <Text>{i18nSubscriberDetailsSidePanel('Activity.Transfer.Date')}:</Text>
          <Text>{formatDate(date, 'DD/MM/YYYY')}</Text>
        </Flex>
        <Flex justifyContent="space-between">
          <Text>{i18nSubscriberDetailsSidePanel('Activity.Transfer.Label')}:</Text>
          <Text>{label || ' - '}</Text>
        </Flex>
        <Flex justifyContent="space-between">
          <Text>{i18nSubscriberDetailsSidePanel('Activity.Transfer.Reference')}:</Text>
          <Text>{reference || ' - '}</Text>
        </Flex>
      </Stack>
    </Stack>
  );
}
